export const LIST_TYPES = ['numbered-list', 'bulleted-list'];

export const HOTKEYS = {
  b: 'bold',
  i: 'italic',
  u: 'underline',
  '`': 'code'
};
